export default {
  market: {
    Applicant: '申请人',
    ApplyTime: '申请时间',
    AuditPass: '审核通过',
    AuditFailed: '审核未通过',
    NotAudit: '未审核',

    ContactMethod: '联系方式',
    AuditStatus: '审核状态',
    ActivityName: '活动名称',
    ActivityContent: '活动内容',
    Location: '地点',
    ApplicationTime: '申请时间',
    ActivityMember: '活动注册会员',
    ActivityCode: '二维码',
    AvtivityStore: '活动门店',
    ChooseDataFirst: '请先选择数据'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/mmc/eurlate/market.js